import { User } from '@supabase/supabase-js';
import { create } from 'zustand';

import { supabase } from '@/common/config/supabase';

interface AuthState {
  user: User | null;
  loading: boolean;
  checkAuthState: () => Promise<void>;
  loginWithGoogle: () => Promise<void>;
  loginWithEmail: (email: string, password: string) => Promise<{ error: Error | null }>;
  signUpWithEmail: (email: string, password: string, name: string) => Promise<{ error: Error | null }>;
  logout: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: true,

  checkAuthState: async () => {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    set({ user: session?.user || null, loading: false });

    // Listen for authentication changes
    supabase.auth.onAuthStateChange((_event, session) => {
      set({ user: session?.user || null });
    });
  },

  loginWithGoogle: async () => {
    const redirectTo = import.meta.env.VITE_REDIRECT_URL
    const { error } = await supabase.auth.signInWithOAuth({ provider: 'google', options: { redirectTo } });
    if (error) alert('Login failed');
  },

  loginWithEmail: async (email: string, password: string) => {
    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    return { error };
  },

  signUpWithEmail: async (email: string, password: string, name: string) => {
    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: {
          name,
        },
      },
    });
    return { error };
  },

  logout: async () => {
    await supabase.auth.signOut();
    set({ user: null });
  },
}));
